import './style.css';
import logoVbrass from '../../img/vbrassLogo.png';
import logoVbrassCuartaSeccion from '../../img/vbrassLogoCuartaSeccion.png';
import imgProyectos from '../../img/inicio/jbl.jpg';
import imgCotizaProyecto from '../../img/inicio/airpods.webp';
import { Link, useHistory } from 'react-router-dom';
import { ScrollContainer } from 'react-indiana-drag-scroll';
import 'react-indiana-drag-scroll/dist/style.css'
import { Carousel } from 'react-bootstrap';
import reviewFace from '../../img/inicio/reviewFace.jpg';
import logoDegradadoAmarillo from '../../img/logoDegradadoAmarillo.png';
import fbAmarillo from '../../img/fbAmarillo.png';
import igAmarillo from '../../img/igAmarillo.png';
import lkdAmarillo from '../../img/lkdAmarillo.png';

function Inicio() {
    const history = useHistory();

    const handleClick = () => {
        history.push('/proyecto'); // cambia a la ruta deseada
    };


    return (  
        <div className="inicio">
            <div className="row rowLogo" style={{ width: '90%', marginInline: 'auto' }}>
                <div className="col-12 col-xl-5">
                    <img src={logoVbrass} alt="" width={"90%"} className="mx-auto d-flex"/>
                </div>
                <div className="col-7 d-none d-xl-flex"></div>
            </div>
            <div className="row primeraSeccion m-0 d-none d-xl-flex">
                <div className="col-5 p-0 h-100">
                    <div className='recortePrimeraSeccion'>
                        <p>Lorem ipsum dolor sit amet, elitr il consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut l</p>
                    </div>
                    <div className='h-75 p-5 pe-0'>
                        <div className='w-100 h-100 contenedorIMG'>
                            <img src={imgCotizaProyecto} alt="" className='imgCotizaProyecto'/>
                            <div className='contenedorBoton'>
                                <Link className='btnCotiza' to={'/contacto'}>Cotiza tu proyecto</Link>
                            </div>
                        </div>        
                    </div>
                </div>
                <div className="col-7 p-5 h-100 d-flex justify-content-center align-items-center">
                    <div className='w-100 h-100 contenedorIMG'>
                        <img src={imgProyectos} alt="" className='imgProyectos'/>
                        <div className='contenedorBoton'>                            
                            <Link className='btnProyectos' to={'/nuestrotrabajo'}>Proyectos</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row primeraSeccionMobile d-flex d-xl-none mt-3">
                <div className="col-12">                    
                    <p>Lorem ipsum dolor sit amet, elitr il consetetur sadipscing elitr, sed diam nonumy eirmod</p>
                </div>
                <div className="col-12 d-flex justify-content-center mt-2">
                    <Link className='btnCotiza' to={'/contacto'}>Cotiza tu proyecto</Link>
                </div>
                <div className="col-12 p-3 colIMG mt-5">
                    <div className='w-100 h-100 contenedorIMG'>
                        <img src={imgCotizaProyecto} alt="" className='imgCotizaProyecto'/>
                        <div className='contenedorBoton'>
                            <Link className='btnProyectos' to={'/nuestrotrabajo'}>Ver más proyectos</Link>
                        </div>
                    </div>  
                </div>
            </div>
            <ScrollContainer className="row m-0 segundaSeccion">
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
                <div className="card" onClick={handleClick}>
                    <div className="coverIMG"></div>
                    <div className="topIMG"></div>
                    <div className="midContainer">
                        <p className='btnCard'>Lorem upsum dolor</p>
                    </div>
                    <div className="btmIMG"></div>
                </div>
            </ScrollContainer>
            <div className='w-100 d-none d-md-flex justify-content-center align-items-center'>
                <Link className='btnVerMasProyectos' to={'/nuestrotrabajo'}> Ver más proyectos</Link>
            </div>
            <div className="row terceraSeccion m-0">
                <Carousel indicators={false} className="h-100" style={{ overflow: 'hidden' }}>
                    <Carousel.Item>
                        <div className="carouselItemContent">
                            <div className="row m-0 d-flex justify-content-center">
                                <img src={reviewFace} alt="" className='reviewFace p-0'/>
                            </div>
                            <div className="row m-0 mt-2 mt-lg-4 d-flex justify-content-center">
                                <h3 className='text-center'>Lorem ipsum</h3>
                            </div>
                            <div className="row m-0 mt-lg-1 d-flex justify-content-center">
                                <h4 className='text-center'>Lorem ipsum</h4>
                            </div>
                            <div className="row m-0 mt-3 mt-lg-5 d-flex justify-content-center">
                                <p className='text-center'>
                                “Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet”
                                </p>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className="carouselItemContent">
                            <div className="row m-0 d-flex justify-content-center">
                                <img src={reviewFace} alt="" className='reviewFace p-0'/>
                            </div>
                            <div className="row m-0 mt-2 mt-lg-4 d-flex justify-content-center">
                                <h3 className='text-center'>Lorem ipsum</h3>
                            </div>
                            <div className="row m-0 mt-lg-1 d-flex justify-content-center">
                                <h4 className='text-center'>Lorem ipsum</h4>
                            </div>
                            <div className="row m-0 mt-3 mt-lg-5 d-flex justify-content-center">
                                <p className='text-center'>
                                “Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet”
                                </p>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </div>
            <div className="row cuartaSeccion m-0 d-flex align-items-center justify-content-center">
                <img src={logoDegradadoAmarillo} alt="" className='logoDegradadoAmarillo'/>
                <div className='content'>
                    <div className="row m-0">
                        <div className="col-lg-7">
                            <img src={logoVbrassCuartaSeccion} alt="" className='w-100'/>
                        </div>
                    </div>
                    <div className="row m-0 mt-4 mt-lg-5">
                        <div className="col-lg-10 col-xxl-6">
                            <h3>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et</h3>
                        </div>
                    </div>
                    <div className="row m-0 mt-4 mt-lg-5">
                        <div className="col-lg-5 col-xxl-4">
                            <Link className='btnCotiza' to={'/contacto'}>Cotiza tu proyecto</Link>
                        </div>
                    </div>
                    <div className="row m-0 mt-5">
                        <div className="col-lg-6 col-xl-5 col-xxl-4 containerRedesSociales">
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={fbAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={lkdAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={igAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Inicio;